import BlCountdownAv from './BlCountdownAv.vue'

BlCountdownAv.install = function(Vue) {
  Vue.component(BlCountdownAv.name, BlCountdownAv)
}

export default BlCountdownAv
